document.addEventListener("DOMContentLoaded", function () {
  // The main fixed background element ID is always 'ck-bg-container'
  const fixedBackground = document.getElementById("ck-bg-container");

  if (!fixedBackground) {
    console.warn("Main background element with ID 'ck-bg-container' not found. Ensure it's present in the HTML.");
    return;
  }

  // Retrieve the dynamic image prefix from the data attribute on the fixedBackground element
  const imagePrefix = fixedBackground.dataset.imagePrefix;

  // Validate the image prefix configuration
  if (!imagePrefix) {
    console.error("Missing 'data-image-prefix' attribute on #ck-bg-container. Image classes cannot be generated.");
    return;
  }

  // The image trigger IDs are now UNIVERSAL and hardcoded in the script
  // These are your fixed triggers across all pages (e.g., from your CK test page)
  const observerTriggerIds = [
    "ck-bg-2", "ck-bg-3", "ck-bg-4", "ck-bg-5", "ck-bg-6",
    "ck-bg-7", "ck-bg-8", "ck-bg-9", "ck-bg-10"
  ];

  // Collect the actual DOM elements to observe
  const observerItems = observerTriggerIds.map((id) => document.getElementById(id)).filter(Boolean);

  if (observerItems.length === 0) {
    console.warn("No observer trigger elements found with the universal IDs. Ensure they are present in the HTML for this page.");
    // If no triggers are found, the script will still attempt to apply the default image 1 below.
  }

  // Dynamically generate ALL image classes (including 'show-image-1') using the extracted prefix
  const imageClasses = [];
  // Loop from 1 up to (number of triggers + 1) to include 'show-image-1'
  for (let i = 1; i <= observerTriggerIds.length + 1; i++) {
    imageClasses.push(`${imagePrefix}-show-image-${i}`);
  }

  // --- NEW: Apply the default image (Image 1) on initial load ---
  // Ensure all other image classes are removed first (important for page transitions)
  imageClasses.forEach(className => fixedBackground.classList.remove(className));
  fixedBackground.classList.add(imageClasses[0]); // Apply the first image (show-image-1) on load


 const customMargin = fixedBackground.dataset.rootMargin || "-50% 0px -50% 0px";

  const observerOptions = {
    root: null, 
    rootMargin: customMargin, // Now dynamic!
    threshold: 0 
  };

  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const triggerIndex = observerTriggerIds.indexOf(entry.target.id);

        if (triggerIndex !== -1) {
          // Remove all existing image classes to ensure only one is active
          imageClasses.forEach((className) => fixedBackground.classList.remove(className));
          // Add the specific class corresponding to the intersecting trigger
          // +1 because imageClasses[0] is 'show-image-1', and triggerIndex 0 is for 'show-image-2'
          fixedBackground.classList.add(imageClasses[triggerIndex + 1]);
        }
      } else {
        // If an element is *leaving* the intersection, revert or change based on scroll direction.
        const triggerIndex = observerTriggerIds.indexOf(entry.target.id);

        if (triggerIndex !== -1) {
          if (entry.boundingClientRect.top > 0) { // Scrolling up (element top is below viewport top)
            // If scrolling up and a section is leaving, apply the *previous* image's class
            if (triggerIndex > 0) {
              imageClasses.forEach((className) => fixedBackground.classList.remove(className)); // Remove all
              fixedBackground.classList.add(imageClasses[triggerIndex]); // Add the class for the previous image
            } else {
              // If leaving the *first* trigger section while scrolling up, revert to the default (image 1)
              imageClasses.forEach((className) => fixedBackground.classList.remove(className));
              fixedBackground.classList.add(imageClasses[0]); // Add show-image-1
            }
          }
          // If scrolling down and an element is leaving, it means we've passed it,
          // and the next element's intersection will handle the swap. No action needed here for scrolling down.
        }
      }
    });

    // Fallback logic for initial load or when no trigger is intersecting (e.g., at very top of page)
    const firstTrigger = observerItems[0];
    if (firstTrigger) {
        // Determine if the scroll position is above the first trigger's activation point
        const isAboveFirstTriggerActivation = window.scrollY + window.innerHeight * 0.5 < firstTrigger.getBoundingClientRect().top + window.scrollY;

        // Check if any trigger is currently intersecting in the "active" zone (midpoint of viewport)
        const anyTriggerActive = observerItems.some(item => {
            const entry = observer.takeRecords().find(rec => rec.target === item);
            return entry && entry.isIntersecting; // 'isIntersecting' checks if it meets the rootMargin/threshold criteria
        });

        // If we are above the first trigger's activation point AND no specific trigger is currently active,
        // ensure the default image (Image 1) is applied.
        if (isAboveFirstTriggerActivation && !anyTriggerActive) {
            imageClasses.forEach((className) => fixedBackground.classList.remove(className));
            fixedBackground.classList.add(imageClasses[0]); // Apply show-image-1
        }
    }
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  // Start observing all trigger elements
  observerItems.forEach((item) => {
    observer.observe(item);
  });
});